/**
 * Main config file for Online Prints Editor
 *
 * The values (#{foo}) that should be different for different environments
 * (dev, prod, test), are handled by Octopus when deploying. These
 * values are also handled by gulp, when building for dev.
 * @type {Object}
 */
export default {
    EditorId: '018b6ef3-c90d-4274-abc4-5f2afe6e9ba1',
    UploadRegistrationApi: '#{UploadRegistrationApi}',
    ProductApi: '#{ProductApi}',
    CurrencyApi: '#{CurrencyApi}',
    EditorGatewayApi: '#{EditorGatewayApi}',
    PhotoOrganiseAuthApi: '#{PhotoOrganiseAuthApi}',
    PhotoOrganiseQueryApi: '#{PhotoOrganiseQueryApi}',
    TemporarySelectionApi: '#{TemporarySelectionApi}',
    oauthClientId: '#{oauthClientId}',
    oauthRedirectUrl: '#{oauthRedirectUrl}',
    oauthAuthorizationUrl: '#{oauthAuthorizationUrl}',
    photoUpload: {
        remap: '#{photoUpload.remap}',
        regex: '#{photoUpload.remapRegex}'
    },
    dynatraceLogger: {
        url: "#{DynatraceLogs.Url}",
        token: "#{DynatraceLogs.ApiToken}"
    },
    EditorModes: {
        standard: ['PAP_910', 'PAP_911', 'PAP_915'],
        polaroid: ['PAP_912']
    },
    PolaroidPrintWidth: 'PAP_910-4.8031',
    EditServerUrl: '#{EditServerUrl}',
    ShowLeavePageWarning: '#{ShowLeavePageWarning}',
    UploadSettings: {
        parallel: 6,
        maxFileSize: '25mb',
        mimeTypes: ['image/jpg', 'image/jpeg', 'image/png'],
        maxNumberOfFiles: 1500,
        maxPhotoPixels: 133930126,
        retry: { //For ajax requests
            times: 5, //How many times should the application try
            waitTimeBetweenRetries: 1000, //The ms waiting between retries
            network: { //For network specifc errors
                times: 500, //Maybe network connection is temporarly down (in ms)
                waitTimeBetweenRetries: 5000 //The ms between each try
            }
        }
    },
    PhotoorganisePerPage: 100,
    ProductCategories: [
        {
            label: null,
            getLabelFromProductId: 'PAP_910',
            products: ['PAP_910']
        },
        {
            label: null,
            getLabelFromProductId: 'PAP_911',
            products: ['PAP_911']
        },
        {
            label: 'Retro',
            products: ['PAP_910_polaroid']
        },
        {
            label: null,
            getLabelFromProductId: 'PAP_912',
            products: ['PAP_912']
        },
        {
            label: "Enlargements",
            products: ['PAP_915']
        }
    ],
    LayoutBreakpoints: {
        small: 640
    },
    UpsellProducts: [
        {from: 'PAP_910', to: 'PAP_911'}
    ],
    NumberOfRetriesOnFail: 10,
    DelayTimeoutDuration: 1000,
    BulkSizeOfUploadImages: 6,
    // maximum time allowed for the upload of a single photo (otherwise defaults to 2 minutes in Chrome)
    // 60000 defines a single minute
    SinglePhotoUploadTimeout: 15 * 60000,
    ProductRatioWarning: 0.025,
    LowResolutionWarningThreshold: 300,
    LowResolutionStopThreshold: 150,
    GalleryImagesPerPage: 24,
    ProductItemsPerPage: 50,
    MemoryManagement: {
        removeOutOfSightImagesAfterSec: 60 //After this amount of seconds, remove images that are not visible on the page from memory
    },
    VendorDefaults: {
        paperType: () => {
            const url = new URLSearchParams(window.location.search);
            if (url.has('paperType')) {
                return url.get('paperType');
            }
            return "GLOSSY"
        }
    },
    VendorVariables: {
        1230: {
            customerServiceUrl: "https://service.storiogroup.com/hc/da/sections/23334484061969",
            privacyUrl: "https://service.storiogroup.com/hc/da/articles/23334332876049",
            disclaimerUrl: "https://www.photobox.dk/brugsvilkar",
            siteUrl: "https://photobox.dk",
            copyrightName: "Photobox",
            allowSelectFromPhotoorganise: false,
            logoClassName: "photobox"
        },
        1229: {
            customerServiceUrl: "https://service.storiogroup.com/hc/it/sections/23334484061969",
            privacyUrl: "https://service.storiogroup.com/hc/it/articles/23334332876049",
            disclaimerUrl: "https://www.photobox.it/condizioni-utilizzo",
            siteUrl: "https://photobox.it",
            copyrightName: "Photobox",
            allowSelectFromPhotoorganise: false,
            logoClassName: "photobox"
        },
        1228: {
            customerServiceUrl: "https://service.storiogroup.com/hc/en-ie/sections/23334484061969",
            privacyUrl: "https://service.storiogroup.com/hc/en-ie/articles/23334332876049",
            disclaimerUrl: "https://www.photobox.ie/terms-conditions",
            siteUrl: "https://photobox.ie",
            copyrightName: "Photobox",
            allowSelectFromPhotoorganise: false,
            logoClassName: "photobox"
        },
        1227: {
            customerServiceUrl: "https://service.storiogroup.com/hc/fr/sections/23334484061969",
            privacyUrl: "https://service.storiogroup.com/hc/fr/articles/23334332876049",
            disclaimerUrl: "https://www.photobox.fr/terms-conditions",
            siteUrl: "https://photobox.fr",
            copyrightName: "Photobox",
            allowSelectFromPhotoorganise: false,
            logoClassName: "photobox"
        },
        1232: {
            customerServiceUrl: "https://service.storiogroup.com/hc/pt/sections/23334484061969",
            privacyUrl: "https://service.storiogroup.com/hc/pt/articles/23334332876049",
            disclaimerUrl: "https://www.hofmann.pt/termos-e-condicoes-de-utilizacao",
            siteUrl: "https://hofmann.pt",
            copyrightName: "Hofmann",
            allowSelectFromPhotoorganise: false,
            logoClassName: "hofmann"
        },
        1231: {
            customerServiceUrl: "https://service.storiogroup.com/hc/es/sections/23334484061969",
            privacyUrl: "https://service.storiogroup.com/hc/es/articles/23334332876049",
            disclaimerUrl: "https://www.hofmann.es/terminos-y-condiciones-de-uso",
            siteUrl: "https://hofmann.es",
            copyrightName: "Hofmann",
            allowSelectFromPhotoorganise: false,
            logoClassName: "hofmann"
        },
        1226: {
            customerServiceUrl: "https://service.storiogroup.com/hc/en-gb/sections/23334484061969",
            privacyUrl: "https://service.storiogroup.com/hc/en-gb/articles/23334332876049",
            disclaimerUrl: "https://www.photobox.co.uk/terms-conditions",
            siteUrl: "https://photobox.co.uk",
            copyrightName: "Photobox",
            allowSelectFromPhotoorganise: false,
            logoClassName: "photobox"
        },
        1200: {
            customerServiceUrl: "https://service.storiogroup.com/hc/nl/sections/23334484061969",
            privacyUrl: "https://service.storiogroup.com/hc/nl/articles/23334332876049",
            disclaimerUrl: "https://albelli.nl/disclaimer",
            siteUrl: "https://albelli.nl",
            copyrightName: "Albelli",
            allowSelectFromPhotoorganise: false,
            logoClassName: "albelli"
        },
        1207: {
            customerServiceUrl: "https://service.storiogroup.com/hc/nl-be/sections/23334484061969",
            privacyUrl: "https://service.storiogroup.com/hc/nl-be/articles/23334332876049",
            disclaimerUrl: "https://albelli.be/disclaimer",
            siteUrl: "https://albelli.be",
            copyrightName: "Albelli",
            allowSelectFromPhotoorganise: false,
            logoClassName: "albelli"
        },
        1201: {
            customerServiceUrl: "https://service.albelli.com/hc/de",
            privacyUrl: "https://albelli.de/datenschutz",
            disclaimerUrl: "https://albelli.de/agb",
            siteUrl: "https://albelli.de",
            copyrightName: "Albelli",
            allowSelectFromPhotoorganise: false,
            logoClassName: "albelli"
        },
        1222: {
            customerServiceUrl: "https://service.storiogroup.com/hc/de/sections/23334484061969",
            privacyUrl: "https://service.storiogroup.com/hc/de/articles/23334332876049",
            disclaimerUrl: "https://posterxxl.de/agb",
            siteUrl: "https://posterxxl.de",
            copyrightName: "posterXXL",
            allowSelectFromPhotoorganise: false,
            logoClassName: "posterxxl"
        },
        1223: {
            customerServiceUrl: "https://service.storiogroup.com/hc/de-at/sections/23334484061969",
            privacyUrl: "https://service.storiogroup.com/hc/de-at/articles/23334332876049",
            disclaimerUrl: "https://posterxxl.at/agb",
            siteUrl: "https://posterxxl.at",
            copyrightName: "posterXXL",
            allowSelectFromPhotoorganise: false,
            logoClassName: "posterxxl"
        },
        1203: {
            customerServiceUrl: "https://albelli.fr/aide/resume",
            privacyUrl: "https://albelli.fr/protection-de-la-vie-privee",
            disclaimerUrl: "https://albelli.fr/conditions-generales",
            siteUrl: "https://albelli.fr",
            copyrightName: "Albelli",
            allowSelectFromPhotoorganise: false,
            logoClassName: "albelli"
        },
        1205: {
            customerServiceUrl: "https://albelli.co.uk/help/overview",
            privacyUrl: "https://albelli.co.uk/privacy-statement",
            disclaimerUrl: "https://albelli.co.uk/disclaimer",
            siteUrl: "https://albelli.co.uk",
            copyrightName: "Albelli",
            allowSelectFromPhotoorganise: false,
            logoClassName: "albelli"
        },
        1221: {
            customerServiceUrl: "https://service.storiogroup.com/hc/en-gb/sections/23334484061969",
            privacyUrl: "https://service.storiogroup.com/hc/en-gb/articles/23334332876049",
            disclaimerUrl: "https://bonusprint.co.uk/about-us/terms",
            siteUrl: "https://bonusprint.co.uk",
            copyrightName: "Bonusprint",
            allowSelectFromPhotoorganise: false,
            logoClassName: "bonusprint"
        },
        1213: {
            customerServiceUrl: "https://service.storiogroup.com/hc/sv/sections/23334484061969",
            privacyUrl: "https://service.storiogroup.com/hc/sv/articles/23334332876049",
            disclaimerUrl: "https://onskefoto.se/villkor",
            siteUrl: "https://onskefoto.se",
            copyrightName: "Önskefoto",
            allowSelectFromPhotoorganise: false,
            logoClassName: "onskefoto"
        },
        1215: {
            customerServiceUrl: "https://service.storiogroup.com/hc/no/sections/23334484061969",
            privacyUrl: "https://service.storiogroup.com/hc/no/articles/23334332876049",
            disclaimerUrl: "https://fotoknudsen.no/vilkar",
            siteUrl: "https://fotoknudsen.no",
            copyrightName: "FotoKnudsen",
            allowSelectFromPhotoorganise: false,
            logoClassName: "fotoknudsen"
        },
        1217: {
            customerServiceUrl: "https://service.storiogroup.com/hc/fr/sections/23334484061969",
            privacyUrl: "https://service.storiogroup.com/hc/fr/articles/23334332876049",
            disclaimerUrl: "https://monalbumphoto.fr/conditions-generales",
            siteUrl: "https://monalbumphoto.fr",
            copyrightName: "Monalbumphoto",
            allowSelectFromPhotoorganise: false,
            logoClassName: "monalbumphoto"
        },
        1224: {
            customerServiceUrl: "https://b2bservice.posterxxl.de/hc/de",
            privacyUrl: "https://b2b.posterxxl.de/datenschutzrichtlinie",
            disclaimerUrl: "https://b2b.posterxxl.de/agb",
            siteUrl: "https://b2b.posterxxl.de",
            copyrightName: "posterXXL business",
            allowSelectFromPhotoorganise: false,
            logoClassName: "posterxxl-b2b"
        },
    },
    ManufacturingData: {
        products: {
            PAP_910: {
                borderWidth: 4,
                dpi: 300
            },
            PAP_910_polaroid: {
                borderWidth: 4,
                dpi: 300
            },
            PAP_911: {
                borderWidth: 6,
                dpi: 300
            },
            PAP_912: {
                borderWidth: 4,
                dpi: 300
            },
            PAP_913: {
                borderWidth: 6,
                dpi: 300
            },
            PAP_914: {
                borderWidth: 6,
                dpi: 300
            },
            PAP_915: {
                borderWidth: 6,
                dpi: 300
            }
        }
    },
    LogLevel: {
        /**
         *  Designates events that are very
         *  harmful and will eventually lead to application failure.
         */
        FATAL: 4,

        /**
         *  Designates error events that might
         *  still allow the application to continue running.
         */
        ERROR: 3,

        /**
         *  Designates events that could be
         *  harmful to the application operation.
         */
        WARN: 2,

        /**
         *  Designates informational messages that
         *  highlight the progress of the application at coarse-grained level.
         */
        INFO: 1,

        /**
         *  Designates informational level
         *  messages that are fine grained and most helpful when debugging an
         *  application.
         */
        DEBUG: 0
    },
    polaroidEnabled: true,
    photoSelector: {
        range: {max: 1400, min: 1},
        photoOrganiserQueryApiUrl: "#{PhotoOrganiseQueryApi}/api/v1", //Will be automatically set by deployment server for each environment
        startPage: "photoorganiser", //what page should the photoselector show on startup
        autoCloseOnSelection: false,
        photoOrganiserAuthenticator: () => Promise.resolve(sessionStorage.getItem("photoOrganiseLoginToken")) //A function that returns a promise which gives a token. Returns empty string if no token available. Only needed if using photoorganiser as image source
    },
    photoOrganiserVendorNames: {
        1213: "minbildbank",
        1215: "minnebanken",
        1217: "Mesphotos"
    }
};
